import {PortalContext, registerPortalRoot} from '@primer/react'
import {type ReactNode, useId, useLayoutEffect, useMemo} from 'react'

const ARTIFACTS_BODY_PORTAL_Z_INDEX = 'var(--artifacts-overlay-z-index, 5)'

export function ArtifactsBodyPortalProvider({children}: {children: ReactNode}) {
  const portalContainerId = useId()
  const portalContextValue = useMemo(() => ({portalContainerName: portalContainerId}), [portalContainerId])

  useLayoutEffect(() => {
    const root = document.createElement('div')
    root.setAttribute('data-artifacts-body-portal-root', '')
    root.style.position = 'relative'
    root.style.zIndex = ARTIFACTS_BODY_PORTAL_Z_INDEX
    document.body.appendChild(root)
    registerPortalRoot(root, portalContainerId)

    return () => {
      root.remove()
    }
  }, [portalContainerId])

  return <PortalContext value={portalContextValue}>{children}</PortalContext>
}
